var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7063 6.33365L5.49601 10.1234L6.48589 9.13347L4.38603 7.03361H10.3881V7.03551C10.407 7.03509 10.426 7.03488 10.445 7.03488C11.8289 7.03488 12.9508 8.15678 12.9508 9.54072C12.9508 10.9247 11.8289 12.0466 10.445 12.0466C10.4449 12.0466 10.4451 12.0466 10.445 12.0466L10.4448 12.0453L3.81163 12.0453L3.81163 13.4557H10.4448C12.5757 13.4254 14.2938 11.6881 14.2938 9.54994C14.2938 7.41186 12.5759 5.67503 10.445 5.64459V5.6337L4.38603 5.6337L6.48589 3.53383L5.49601 2.54395L1.7063 6.33365Z",
    fill: "#697180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.4903642d745af8410237790722591e17.svg";
export { ForwardRef as ReactComponent };